import { sql } from "drizzle-orm";
import { check, index, integer, jsonb, pgTable, text, timestamp, uniqueIndex, varchar } from "drizzle-orm/pg-core";
import { organisations, users } from "./schemaBase.js";

/** A durable debt to tell staff about actionable work, independently of the bell. */
export const staffActionAlerts = pgTable("staff_action_alerts", {
  id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
  organisationId: varchar("organisation_id").notNull().references(() => organisations.id, { onDelete: "restrict" }),
  kind: text("kind").notNull(),
  itemId: text("item_id").notNull(),
  responsibleAccountId: varchar("responsible_account_id").references(() => users.id, { onDelete: "set null" }),
  actorUserId: varchar("actor_user_id").references(() => users.id, { onDelete: "set null" }),
  dueAt: timestamp("due_at", { withTimezone: true }),
  payload: jsonb("payload").notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  notifiedAt: timestamp("notified_at", { withTimezone: true }),
  remindedAt: timestamp("reminded_at", { withTimezone: true }),
  escalatedAt: timestamp("escalated_at", { withTimezone: true }),
  resolvedAt: timestamp("resolved_at", { withTimezone: true }),
  attempts: integer("attempts").notNull().default(0),
  retryAfter: timestamp("retry_after", { withTimezone: true }),
  lastError: text("last_error"),
}, t => [
  uniqueIndex("staff_action_alerts_item_idx").on(t.organisationId, t.kind, t.itemId),
  index("staff_action_alerts_pending_idx").on(t.organisationId, t.resolvedAt, t.retryAfter),
  check("staff_action_alerts_kind_check", sql`${t.kind} in ('on_site_request', 'waitlist_request', 'retention_follow_up')`),
]);
